import axiosInstance from "../AxiosInstance";
import {
  ACTIVE_FLAG_POSTING_LIST,
  BLOCK_USER,
  DASHBOARD,
  FLAG_POSTING_LIST,
  JOB_CATEGORY_LIST,
  JOB_DETAILS,
  JOB_POSTING_LIST,
  PRICE,
  SERVICE_CATEGORY_LIST,
  SERVICE_DETAILS,
  SERVICE_POSTING_LIST,
  USER_DASHBOARD,
  USER_EVENT,
  USER_SUB_EVENTS,
  USER_TASKS,
  USERDETAIL,
  USERLIST,
} from "./UserEndpoint";

export function getUserList(page, limit, search) {
  return axiosInstance.get(`${USERLIST}?page=${page}&limit=${limit}&${search ? `search=${search}` : ""}`);
}



export function getUserDetail(id) {
  return axiosInstance.get(`${USERDETAIL}?id=${id}`);
}


export function getUserEvent(id) {
  return axiosInstance.get(`${USER_EVENT}?userId=${id}`);
}


export function getUserSubEvent(id1,id2) {
  return axiosInstance.get(`${USER_SUB_EVENTS}?userId=${id1}&eventId=${id2}`);
}


export function getUserTasks(id1,id2) {
  return axiosInstance.get(`${USER_TASKS}?userId=${id1}&eventId=${id2}`);
}

export function getDashboardTemp() {
  return axiosInstance.get(`${USER_DASHBOARD}`);
}





// export function getUserSubEvent(id1, id2) {
//   return axiosInstance.post(`${USER_SUB_EVENTS}`, {
//     userId: id1,
//     eventId: id2
//   });
// }





export function getJobCategoryList(page, limit, search) {
  return axiosInstance.get(
    `${JOB_CATEGORY_LIST}?page=${page}&limit=${limit}&search=${search}`
  );
}

export function getServiceCategoryList(page, limit, search) {
  return axiosInstance.get(
    `${SERVICE_CATEGORY_LIST}?page=${page}&limit=${limit}&search=${search}`
  );
}

export function postJobCategory(postData) {
  return axiosInstance.post(
    JOB_CATEGORY_LIST,
    postData
  );
}

export function postServiceCategory(postData) {
  return axiosInstance.post(
    SERVICE_CATEGORY_LIST,
    postData
  );
}

export function deleteJobCategory(id) {
  return axiosInstance.delete(
    `${JOB_CATEGORY_LIST}?categoryId=${id}`
  );
} 

export function deleteServiceCategory(id) {
  return axiosInstance.delete(
    `${SERVICE_CATEGORY_LIST}?categoryId=${id}`
  );
}

export function updateJobCategory(postData) {
  return axiosInstance.put(
    `${JOB_CATEGORY_LIST}`,
    postData
  );
}

export function updateServiceCategory(postData) {
  return axiosInstance.put(
    `${SERVICE_CATEGORY_LIST}`,
    postData
  );
}

export function jobPostingData(currentPage,search) {
  return axiosInstance.get(
    `${JOB_POSTING_LIST}?page=${currentPage}&search=${search}`
  );
}

export function flagPostingData(currentPage) {
  return axiosInstance.get(
    `${FLAG_POSTING_LIST}?page=${currentPage}`
  );
}

export function activeJobServicePostingData(data) {
  return axiosInstance.put(
    `${ACTIVE_FLAG_POSTING_LIST}`,data
  );
}

export function deleteJobPostingData(id) {
  return axiosInstance.delete(
    `${JOB_POSTING_LIST}?jobId=${id}`
  );
}

export function servicePostingData(currentPage,search) {
  return axiosInstance.get(
    `${SERVICE_POSTING_LIST}?page=${currentPage}&search=${search}`
  );
}

export function deleteServicePostingData(id) {
  return axiosInstance.delete(
    `${SERVICE_POSTING_LIST}?serviceId=${id}`
  );
}

export function getJobDetails(id) {
  return axiosInstance.get(`${JOB_DETAILS}?jobId=${id}`);
}

export function getServiceDetails(id) {
  return axiosInstance.get(`${SERVICE_DETAILS}?serviceId=${id}`);
}

export function blockUser(data) {
  return axiosInstance.post(`${BLOCK_USER}`,data);
}

export function getPrice() {
  return axiosInstance.get(`${PRICE}`);
}

export function getDashboard(startDate, endDate) {
  return axiosInstance.get(`${DASHBOARD}?${startDate ? `startDate=${startDate}` : ""}&${endDate ? `endDate=${endDate}` : ""}`);
}

export function updatePrice(data) {
  return axiosInstance.put(`${PRICE}`, data);
}